import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'react-apollo'
import qs from 'query-string'
import { LEGACYIDENTIFIER } from '../../../shared/paths'
import CentreMapComponent from '../../components/centre-map'
import { centreType } from '../../types'
import pagesHoc from '../pages-hoc'
import withStores from '../../containers/with-stores'
import withStoreTitle from '../../containers/with-store-title'
import styles from './index.scss'

const getMetaData = ({ centre, storeTitle }) => {
  if (storeTitle) {
    return {
      title: `${storeTitle} Location at Westfield ${centre.title}`,
      description: `Westfield ${
        centre.title
      } ${storeTitle} - Check map locations and directions to help you find ${storeTitle} in Westfield ${
        centre.title
      }.`,
    }
  } else {
    return {
      title: `Westfield ${centre.title} Centre Map | Map of Stores in Centre`,
      description: `Locate your favourite store using our handy centre map with level by level directories of stores, key facilities and amenities at Westfield ${
        centre.title
      }.`,
    }
  }
}

const CentreMap = ({ centre, match, stores, history }) => {
  const entryId = qs.parse(history.location.search, {
    ignoreQueryPrefix: true,
  }).entryId

  return (
    <div className={styles.mapContainer}>
      <CentreMapComponent
        centre={centre}
        history={history}
        stores={stores}
        legacyIdentifier={match.params[LEGACYIDENTIFIER]}
        entryId={entryId}
      />
    </div>
  )
}

CentreMap.propTypes = {
  centre: centreType,
  match: PropTypes.object.isRequired,
  stores: PropTypes.array,
  history: PropTypes.object,
}

export default compose(
  withStores,
  withStoreTitle
)(pagesHoc(CentreMap, getMetaData))
